<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                :items="electronicDevices"
                item-text="name"
                item-value="val"
                v-model="electronicDeviceId"
                label="Blagajna"
              ></v-select>
              <FormErrors
              v-if="$v.$error && (!$v.electronicDeviceId.required)"
            >
              <FormErrorsLine v-if="!$v.electronicDeviceId.required" text="Polje je obvezno" />
            </FormErrors>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                v-if="!loading && invoices.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="download"
              >
                Shrani
                <v-icon right dark>fas fa-save</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                v-if="!loading && invoices.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print"
              >
                Tiskaj
                <v-icon right dark>fas fa-print</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
      </v-row>
      <div v-show="!loading">
        <v-row v-for="invoice in invoices" :key="invoice.id">
          <v-col>
            <InvoiceCard
              :invoice="invoice"
              :businessUnitCode="businessUnitCode"
              :disabled="true"
            />
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="print-control-tape">
      <PrintControlTape
        v-if="company && businessUnit"
        ref="printControlTape"
        :invoices="invoices"
        :invoiceHeader="invoiceHeader"
        :businessUnit="businessUnit"
        :company="company"
        :startDateTime="`${this.startDate} ${this.startTime}`"
        :endDateTime="`${this.endDate} ${this.endTime}`"
      />
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import InvoiceCard from '@/components/InvoiceCard'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import PrintControlTape from '@/components/PrintControlTape'

export default {
  components: {
    InvoiceCard,
    DateTimeSelector,
    FormErrors,
    FormErrorsLine,
    PrintControlTape
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      electronicDeviceId: null,
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      loading: false
    }
  },
  validations () {
    return {
      electronicDeviceId: {
        required
      }
    }
  },
  computed: {
    company () {
      return this.$store.state.companies.myCompany
    },
    businessUnitCode () {
      return this.$store.state.businessUnits.currentBusinessUnit.business_premise_id
    },
    device () {
      return this.$store.state.devices[this.electronicDeviceId]
    },
    businessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    businessUnitId () {
      return this.$store.state.businessUnits.currentBusinessUnit.id
    },
    electronicDevices () {
      return Object.values(this.$store.state.devices.items).map(device => ({
        name: `${device.name} (${device.electronic_device_id})`,
        val: device.id
      }))
    },
    paymentTypes () {
      return Object.values(this.$store.state.paymentTypes.items)
    },
    invoices () {
      return Object.values(this.$store.state.invoices.items)
        .map(invoice => {
          return {
            ...invoice,
            taxGroups: this.taxGroups(invoice.articles)
          }
        })
        .sort((a, b) => {
          return moment(a.date).isBefore(b.date) ? -1 : 1
        })
    },
    invoiceHeader () {
      return this.$store.state.devices.invoiceHeader
    },
    currentInvoicePaymentType () {
      return this.currentInvoice !== null ? this.currentInvoice.payment_type : 0
    },
    params () {
      return {
        businessUnitId: this.businessUnitId,
        electronicDeviceId: this.electronicDeviceId,
        dateFrom: moment(`${this.startDate} ${this.startTime}:00`).format('YYYY-MM-DDTHH:mm:ss'),
        dateTo: moment(`${this.endDate} ${this.endTime}:59`).format('YYYY-MM-DDTHH:mm:ss')
      }
    }
  },
  methods: {
    ...mapActions('paymentTypes', { loadPaymentTypes: 'loadItems' }),
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('devices', ['getHeader']),
    ...mapActions('invoices', { findInvoices: 'loadItemsWithClients' }),
    ...mapActions('invoices', ['clearInvoices']),
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    },
    search () {
      this.$v.$touch()
      if (!this.$v.$error) {
        this.loading = true
        Promise.all([
          this.getHeader({ electronicDeviceId: this.params.electronicDeviceId }),
          this.findInvoices(this.params)
        ])
          .then(response => {
            this.loading = false
          })
          .catch(anErr => {
            this.loading = false
            this.$notify({
              type: 'error',
              text: 'Prišlo je do napake pri nalaganju računov.'
            })
          })
      }
    },
    print () {
      window.print()
    },
    download () {
      let routeData = this.$router.resolve({ name: 'MyCompanyControlTapeDownload',
        query: {
          deviceId: this.electronicDeviceId,
          startDateTime: `${this.startDate} ${this.startTime}:00`,
          endDateTime: `${this.endDate} ${this.endTime}:59`,
          shouldSave: true
        } })
      window.open(routeData.href, '_blank')
    },
    taxGroups (articles) {
      const groups = {}
      articles.forEach(article => {
        const key = article.tax_level_value.toString()
        if (groups[key]) {
          groups[key].taxable_amount += article.taxable_amount
          groups[key].tax_amount += article.tax_amount
          groups[key].price += article.total_amount
        } else {
          groups[key] = {
            tax_level_value: article.tax_level_value,
            taxable_amount: article.taxable_amount,
            tax_amount: article.tax_amount,
            price: article.total_amount
          }
        }
      })
      return Object.values(groups)
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const today = moment().format('YYYY-MM-DD')
      this.startDate = today
      this.endDate = today
      Promise.all([
        this.clearInvoices(),
        this.loadPaymentTypes(),
        this.loadDevices()
      ])
        .then(response => {
          this.asyncDataStatus_fetched()
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        })
    }
  }
}

</script>

<style lang="scss" scoped>
.print-control-tape {
  display: none;
}
@media print {
  .print-control-tape {
    display: block;
    font-size: 10px;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
